import type {
  GetPredictionMarketsDiscoverParams,
  GetPredictionMarketsParams,
  GetPromotedMarketsParams,
  MarketSubCategory,
} from '../services/interfaces/market.types';

export const STALE_TIME = 30_000;
export const MARKET_QUERY_KEY_PREFIX = 'market';
export const INFINITE_SCROLL_PAGE_SIZE = 20;
export const PREFETCH_PREVIEW_PAGE_SIZE = 5;
export const PROMOTED_MARKETS_PAGE_SIZE = 10;

export const MarketQueryKeys = {
  ACCOUNT_ALL: () => [MARKET_QUERY_KEY_PREFIX, 'account'],

  ACCOUNT: (locationState?: string) => [MARKET_QUERY_KEY_PREFIX, 'account', locationState],

  SUB_CATEGORIES: () => [MARKET_QUERY_KEY_PREFIX, 'sub_categories'],

  PREDICTION_MARKETS_DISCOVER: (params?: GetPredictionMarketsDiscoverParams) => [
    MARKET_QUERY_KEY_PREFIX,
    'prediction_markets',
    'discover',
    params,
  ],

  PREDICTION_MARKETS: (params: Omit<GetPredictionMarketsParams, 'offset' | 'limit'>) => [
    MARKET_QUERY_KEY_PREFIX,
    'prediction_markets',
    params.sub_category,
    params.types?.join(','),
  ],

  PREDICTION_MARKETS_PROMOTED: (params?: GetPromotedMarketsParams) => [
    MARKET_QUERY_KEY_PREFIX,
    'prediction_markets',
    'promoted',
    params,
  ],

  PREDICTION_MARKETS_PREVIEW: (subCategory: MarketSubCategory) => [
    MARKET_QUERY_KEY_PREFIX,
    'prediction_markets',
    'preview',
    subCategory,
  ],

  PREDICTION_MARKET: (marketId: string) => [MARKET_QUERY_KEY_PREFIX, 'prediction_market', marketId],

  PORTFOLIO_SUMMARY: () => [MARKET_QUERY_KEY_PREFIX, 'portfolio', 'summary'],

  STATEMENT: (year: number, month: number) => [MARKET_QUERY_KEY_PREFIX, 'statement', year, month],

  GAME_DETAIL: (gameId: string) => [MARKET_QUERY_KEY_PREFIX, 'game_detail', gameId],

  PLAYER_PROPS_ALL: () => [MARKET_QUERY_KEY_PREFIX, 'player_props'],

  PLAYER_PROPS: (eventId: string) => [MARKET_QUERY_KEY_PREFIX, 'player_props', eventId],

  PLAYER_PROPS_SECTION: (eventId: string, propType: string, teamId?: string) => [
    MARKET_QUERY_KEY_PREFIX,
    'player_props',
    eventId,
    propType,
    teamId ?? null,
  ],

  PLAYER_PROPS_GROUP: (playerGroupId: string) => [
    MARKET_QUERY_KEY_PREFIX,
    'player_props',
    'group',
    playerGroupId,
  ],
} as const;

export const MarketMutationKeys = {
  CREATE_ORDER: (marketId: string) => [MARKET_QUERY_KEY_PREFIX, 'create_order', marketId],

  CANCEL_ORDER: (orderId: string) => [MARKET_QUERY_KEY_PREFIX, 'cancel_order', orderId],

  UPDATE_ACCOUNT: () => [MARKET_QUERY_KEY_PREFIX, 'update_account'],
} as const;
